import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { generateDataTestId } from '../../../internal/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Обертка для элементов форм, которая позволяет указать лейбл и ошибку
 *
 * Имеет внешний отступ снизу, который можно отключить
 */
export const FormField = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  const {
    label,
    errorMessage,
    description,
    required,
    withoutMargin,
    dataTestId,
    children
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: clsx(styles['field'], !!errorMessage && styles['hasError'], !!withoutMargin && styles['withoutMargin']),
    "data-testid": dataTestId,
    children: [label && /*#__PURE__*/_jsx("label", {
      className: clsx(styles['label'], !!required && styles['required']),
      "data-testid": generateDataTestId(dataTestId, ['label']),
      children: label
    }), children, /*#__PURE__*/_jsx(Subtext, {
      dataTestId: dataTestId,
      description: description,
      errorMessage: errorMessage
    })]
  });
});
function Subtext(_ref) {
  let {
    dataTestId,
    description,
    errorMessage
  } = _ref;
  if (!errorMessage && !description) {
    return null;
  }
  const state = errorMessage ? 'error' : 'description';
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles[state], styles['subtext']),
    "data-testid": generateDataTestId(dataTestId, [state]),
    children: errorMessage || description
  });
}